import React from 'react'

const SelectFromArray = ({options, name, value,  onChange, classExtra='', iff=true}) => {


	return (
		<select
			className={`form-control ${classExtra}`}
			name={name}
			onChange={(e) => onChange(name, e.target.value)}
			value={value}
		>
			{iff && options().map(item => (
				<option key={item} >
					{item}
				</option>
			))}
		</select>
	)
}

export default SelectFromArray
